import React from 'react'
// import './materialize.min.css'
import './tailwind.css'



const Project = () => {
    return (
       <div className=" py-5 bg-gray-700"  id="projects" >
        <div className="container ">   
        <h1 className="text-center text-3xl font-mono mt-3 text-white">Recent Projects</h1>     
            <div className="grid lg:grid-cols-2 mt-5 gap-4 text-white  ">
                {/* <div className="px-16 py-18 bg-g"></div> */}
               <div className="px-14 py-16 bg-gray-600">
                   <h2 className="font-bold">CryptoCurrency Price Tracker 💸</h2>
                   <p className="mt-3">A CryptoCurrency Website that keeps track of over 180 CryptoCurrencies</p>
                   <br/>
                   <a href="https://github.com/OFUZORCHUKWUEMEKE/CRYPTO-PRICE-TRACKER"  target="_blank"  rel="noreferrer noopener" className="mt-5 hover:text-black "><i className="fab fa-github fa-lg mr-2"></i>Repo</a>
                   <a href="https://crypto-pricetracker.netlify.app/"  target="_blank"  rel="noreferrer noopener" className="ml-8 mt-5 hover:text-black "><i class="fas fa-code-branch  fa-lg mr-2"></i>Live Site</a>
                   <div className="mt-5 flex uppercase font-bold flex-wrap md:justify-around">
                       <button  className="py-1 px-2 bg-gray-500 rounded-md">Javascript</button>
                       <button  className="py-1 px-2 bg-gray-500 rounded-md ">React</button>
                       <button  className="py-1 px-2 bg-gray-500 rounded-md">Bootstrap</button>
                       <button  className="py-1 px-2 bg-gray-500 rounded-md">Materialize Css</button>
                       
                   </div>
               </div>
               <div className="px-14 py-16 bg-gray-600">
                   <h2 className="font-bold">Job For DEVS</h2>
                   <p className="mt-3">A Job-Listing Website for developers,with over a 1000 new jobs added daily..</p>
                   <br/>
                   <a href="https://github.com/OFUZORCHUKWUEMEKE/JOB-FOR-DEVS"  target="_blank"  rel="noreferrer noopener" className="mt-5 hover:text-black"><i class="fab fa-github fa-lg"></i>Repo</a>
                   <a href="https://jobsfordevs.netlify.app/"  target="_blank"  rel="noreferrer noopener" className="ml-3 hover:text-black"><i class="fas fa-code-branch  fa-lg"></i>Live Site</a>
                   <div className="mt-5 flex uppercase font-bold flex-wrap md:justify-around">
                       <button  className="py-1 px-2  bg-gray-500 rounded-md">Javascript</button>
                       <button  className="py-1 px-2  bg-gray-500 rounded-md ">React</button>
                       <button  className="py-1 px-2  bg-gray-500 rounded-md">GitHub API</button>
                       <button  className="py-1 px-2  bg-gray-500 rounded-md">Materialize Css</button>
                       
                   </div>
               </div>
               <div className="px-14 py-16 bg-gray-600">
                   <h2 className="font-bold">EndSars 🇳🇬 </h2>
                   <p className="mt-3">A website that create's awareness on the adverse effect of Police Brutality.And enlighten's the Youth on the Power of Unity and One Voice through Peaceful Protests.</p>
                   <br/>
                   <a href="https://github.com/OFUZORCHUKWUEMEKE/ENDSARS"  target="_blank"  rel="noreferrer noopener" className="mt-5 hover:text-black"><i class="fab fa-github fa-lg"></i>Repo</a>
                   <a href="https://endsarrs.netlify.app/"  target="_blank"  rel="noreferrer noopener" className="ml-3 hover:text-black"><i class="fas fa-code-branch  fa-lg"></i>Live Site</a>
                   <div className="mt-5 flex uppercase font-bold flex-wrap md:justify-around">
                       <button  className="py-1 px-2  bg-gray-500 rounded-md">Javascript</button>
                       <button  className="py-1 px-2  bg-gray-500 rounded-md ">HTML</button>

                       <button  className="py-1 px-2  bg-gray-500 rounded-md"> Reactjs</button>
                       
                       
                   </div>
               </div>
               <div className="px-14 py-16 bg-gray-600">
                   <h2 className="font-bold">Covid 19 Tracker</h2>
                   <p className="mt-3">A Website that keeps track of the global statistics of all corona virus cases</p>
                   
                   <br/>
                   <a href="https://github.com/OFUZORCHUKWUEMEKE/Covid-Tracker-v-2"  target="_blank"  rel="noreferrer noopener" className="mt-5 hover:text-black"><i class="fab fa-github fa-lg"></i>Repo</a>
                   <a href="https://covid-9teeninfo.netlify.app/"  target="_blank"  rel="noreferrer noopener" className="ml-3 hover:text-black"><i class="fas fa-code-branch  fa-lg"></i>Live Site</a>
                   <div className="mt-5 flex uppercase font-bold flex-wrap md:justify-around">
                       <button  className="py-1 px-2  bg-gray-500 rounded-md">HTML</button>
                       <button  className="py-1 px-2  bg-gray-500 rounded-md">Css</button>
                       <button  className="py-1 px-2  bg-gray-500 rounded-md">Javascript</button>
                       
                   </div>
               </div>
              
               <div className="px-14 py-16 bg-gray-600">
                   <h2 className="font-bold">Mama Emeke Egg Depot</h2>
                   <p className="mt-3">A Personal Website i built for my mum. Where you can order eggs online</p>
                   <br/>
                   <a href="https://github.com/OFUZORCHUKWUEMEKE/Mama-Emeke-Egg-Depot"  target="_blank"  rel="noreferrer noopener" className="mt-5 hover:text-black"><i class="fab fa-github fa-lg"></i>Repo</a>
                   <a href="https://mamaemeke.netlify.app/"  target="_blank"  rel="noreferrer noopener" className="ml-3 hover:text-black"><i class="fas fa-code-branch  fa-lg"></i>Live Site</a>
                   <div className="mt-5 flex uppercase font-bold flex-wrap md:justify-around">
                       <button  className="py-1 px-2  bg-gray-500 rounded-md">J-QUERY</button>
                       <button  className="py-1 px-2  bg-gray-500 rounded-md ">HTML</button>
                       <button  className="py-1 px-2  bg-gray-500 rounded-md">Materialize Css</button>
                       
                   </div>
               </div>
               <div className="px-14 py-16 bg-gray-600">
                   <h2 className="font-bold">TruheightMil 👷</h2>
                   <p className="mt-3">A website I built for a Building Construction Company (TRUHEIGHTMIL).   </p>
                   <br/>
                   <a href="https://github.com/OFUZORCHUKWUEMEKE/TRUHEIGHTMIL.COM"  target="_blank"  rel="noreferrer noopener" className="mt-5 hover:text-black"><i class="fab fa-github fa-lg"></i>Repo</a>
                   <a href="https://www.truheightmil.com/"  target="_blank"  rel="noreferrer noopener" className="ml-3 hover:text-black"><i class="fas fa-code-branch  fa-lg"></i>Live Site</a>
                   <div className="mt-5 flex uppercase font-bold flex-wrap md:justify-around">
                       <button  className="py-1 px-2  bg-gray-500 rounded-md">HTML</button>
                       <button  className="py-1 px-2  bg-gray-500 rounded-md">Materialize Css</button>
                       
                   </div>
               </div>
               <div className="px-14 py-16 bg-gray-600">
                   <h2 className="font-bold">Covid-Tracker v-2 </h2>
                   <p className="mt-3">A re-make of the first covid tracker,built with Reactjs </p>
                   <br/>
                   <a href="https://github.com/OFUZORCHUKWUEMEKE/Covid-19-Tracker"  target="_blank"  rel="noreferrer noopener" className="mt-5 hover:text-black"><i class="fab fa-github fa-lg"></i>Repo</a>
                   <a href="https://covidd2020.netlify.app/"  target="_blank"  rel="noreferrer noopener" className="ml-3 hover:text-black"><i class="fas fa-code-branch  fa-lg"></i>Live Site</a>
                   <div className="mt-5 flex uppercase font-bold flex-wrap md:justify-around">
                       <button  className="py-1 px-2  bg-gray-500 rounded-md">Javascript</button>
                       <button  className="py-1 px-2  bg-gray-500 rounded-md ">HTML</button>

                       <button  className="py-1 px-2  bg-gray-500 rounded-md"> Reactjs</button>
                       <button  className="py-1 px-2  bg-gray-500 rounded-md"> Chartjs</button>
                       
                   </div>
               </div>
               <div className="px-14 py-16 bg-gray-600">
                   <h2 className="font-bold">Breaking Bad Search </h2>
                   <p className="mt-3">A website that lists all the characters in the Breaking Bad Series </p>
                   <br/>
                   <a href="https://github.com/OFUZORCHUKWUEMEKE/Breaking-Bad"  target="_blank"  rel="noreferrer noopener" className="mt-5 hover:text-black"><i class="fab fa-github fa-lg"></i>Repo</a>
                   <a href="https://breakingbadtapi.netlify.app"  target="_blank"  rel="noreferrer noopener" className="ml-3 hover:text-black"><i class="fas fa-code-branch  fa-lg"></i>Live Site</a>
                   <div className="mt-5 flex uppercase font-bold flex-wrap md:justify-around">
                       <button  className="py-1 px-2  bg-gray-500 rounded-md">Javascript</button>
                       <button  className="py-1 px-2  bg-gray-500 rounded-md ">HTML</button>

                       <button  className="py-1 px-2  bg-gray-500 rounded-md"> Reactjs</button>
                       
                       
                   </div>
               </div>               
            </div>
        </div>
       </div>
          
    )
}

export default Project
